import { getFullUrl } from 'hubspot-url-utils';
import { ACCOUNT_MENU_WIDTH } from './constants';
import styled, { css } from 'foundations-theming/utils';
import { useIsHubless, useTranslation } from '../../hooks/useNavConfig';
import getPrivacyPolicyLink from '../../utils/getPrivacyPolicyLink';
import { MenuItem } from '../Menu';
import { ButtonWithDemoExitConfirmation } from '../DemoExitConfirmation/ButtonWithDemoExitConfirmation';
import { getAccountMenuBorder, getAccountMenuItemPadding } from './shared-styles';
import { getTypographyStyles } from '../../nav-ui-components/Text';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledMenuItem = styled(MenuItem)(({
  $isHubless,
  theme
}) => css(["list-style-type:none !important;margin-top:", ";border-top:", ";display:inline-flex;padding:", " !important;width:", ";justify-content:left;&:last-of-type{justify-content:right;}a{color:", " !important;", " text-decoration:none;display:inline-block;&:focus,&:hover{text-decoration:underline !important;}}"], $isHubless ? theme.space['0'] : `${theme.space['250']} !important`, $isHubless ? theme.space['0'] : `${getAccountMenuBorder(theme)} !important`, getAccountMenuItemPadding(theme), `${ACCOUNT_MENU_WIDTH / 2 - 1}px`, theme.color['text-interactive-default'], getTypographyStyles(theme, 'heading-25')));
const AccountFooterLink = ({
  text: itemText,
  href,
  id
}) => {
  const isHubless = useIsHubless();
  return /*#__PURE__*/_jsxs(ButtonWithDemoExitConfirmation, {
    component: StyledMenuItem,
    $isHubless: isHubless,
    id: id,
    href: href,
    children: [' ', itemText]
  });
};
const AccountFooter = () => {
  const {
    t
  } = useTranslation();
  const accountFooterItems = [{
    id: 'signout',
    href: `${getFullUrl('app')}/login-api/v1/logout/all`,
    text: t('nav.tools.signOut')
  }, {
    id: 'privacyPolicy',
    href: getPrivacyPolicyLink(),
    text: t('nav.tools.privacy')
  }];
  return /*#__PURE__*/_jsx(_Fragment, {
    children: accountFooterItems.map(itemData => /*#__PURE__*/_jsx(AccountFooterLink, Object.assign({}, itemData), itemData.id))
  });
};
export default AccountFooter;